export const TITLE_DEFAULT = 'Khách hàng';
export const TITLE = {
    login_today: 'Khách đăng nhập hôm nay',
    login: 'Khách đã đăng nhập',
    register_today: 'Khách đăng ký hôm nay',
    blocked: 'Khách đã bị khóa',
    warning: 'Khách bị kiểm tra robot'
};
